enum StatusValue {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Closed = 'CLOSED',
  Upcoming = 'UPCOMING',
  Deleted = 'DELETED',
}

export default StatusValue;
